<template>
    <div class="heartsvg">
        <div class="container">
            <div class="row">
                <div class="col-12">
                    <div class="bg-heart lax w-100" id="bg-heart">

                        <svg xmlns="http://www.w3.org/2000/svg" :width="vwidth" :height="vheight" viewBox="0 0 500 425">
                            <path d="M461.54,76.92V38.46H423.08V0H307.69V38.46H269.23V76.92H230.77V38.46H192.31V0H76.92V38.46H38.46V76.92H0V192.31H38.46v38.46H76.92v38.46h38.46v38.46h38.47v38.46h38.46v38.47h38.46v38.46h38.46V384.62h38.46V346.15h38.46V307.69h38.47V269.23h38.46V230.77h38.46V192.31H500V76.92Zm0,76.93H423.08V115.38H384.62V76.92H346.15V38.46h38.47V76.92h38.46v38.46h38.46Z" :fill="vcolor" :opacity="vopacity" />
                            <animateTransform
                                attributeName="transform"
                                type="scale"
                                values="0.8; 1; 0.9; 1; 1; 0.8;"
                                dur="1.3s"
                                repeatCount="indefinite"
                                additive="sum" >
                            </animateTransform>
                        </svg>

                        <slot></slot>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'HeartSVG',
    props: {
        vcolor: {
            type: String,
            default: '#FF6347'
        },
        vopacity: {
            type: Number,
            default: 0.5
        },
        bounce: Boolean,
        vwidth: {
            type: Number,
            default: 150
        },
        vheight: {
            type: Number,
            default: 150
        }
  },
  data () {
    return {
        scrollPosition: null
    }
}
}
</script>

<style lang="scss">
$tomato: #FF6347;
.heartsvg{
    h3{
        padding: 30px 0;
    }
}

</style>
